export const ENTER_APP_RETURN_TO = '/workspace/';

interface NavigateToEnterAppOptions {
    replace?: boolean;
    origin?: string;
}

export function navigateToEnterApp(options: NavigateToEnterAppOptions = {}): void {
    const target = new URL(
        ENTER_APP_RETURN_TO,
        options.origin ?? window.location.origin
    ).toString();

    if (options.replace) {
        window.location.replace(target);
        return;
    }

    window.location.href = target;
}

export function createEnterAppAuthState(returnTo: string = ENTER_APP_RETURN_TO): { returnTo: string } {
    return { returnTo };
}

export function resolveAuthReturnTo(
    returnTo: unknown,
    origin: string = window.location.origin
): string {
    if (typeof returnTo !== 'string' || !returnTo.trim()) {
        return ENTER_APP_RETURN_TO;
    }

    try {
        const nextUrl = new URL(returnTo, origin);
        if (nextUrl.origin !== origin) {
            return ENTER_APP_RETURN_TO;
        }

        return `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}` || ENTER_APP_RETURN_TO;
    } catch {
        return ENTER_APP_RETURN_TO;
    }
}
